import { createStore } from 'vuex'
import crypto from 'crypto-js' 
import config from '../../config.json'
import version from '../../version.json'
import $ from 'jquery'

export default createStore({
    state: {
        version,
        config,
        cardAccounts: null,
        loader: false,
        receiptLoader: false,
        IFrame: true,
        errorFromServer: null
    },
    getters: {
        ApiPath(state) {
            return state.config.api.url
        },
        ApiKey(state) {
            return state.config.api.key
        }
    },
    mutations: {
        setCardAccounts(state, cardAccounts) {
            state.cardAccounts = cardAccounts

            if (cardAccounts) {
                localStorage.setItem('sessionCardAccounts', crypto.AES.encrypt(JSON.stringify(cardAccounts), '147258369').toString())
            }

            var session_timeout = setTimeout(() => {
                state.cardAccounts = null
                localStorage.removeItem('sessionCardAccounts')
                location.reload()
            }, state.config.session_expired_timeout)
            
            $('#app').mousemove(() => {
                clearTimeout(session_timeout)
                session_timeout = setTimeout(() => {
                    state.cardAccounts = null
                    localStorage.removeItem('sessionCardAccounts')
                    location.reload()
                }, state.config.session_expired_timeout)
            })
        },
        setLoader(state, loader) {
            state.loader = loader
        },
        setReceiptLoader(state, receiptLoader) {
            state.receiptLoader = receiptLoader
        },
        setIFrame(state, IFrame) {
            state.IFrame = IFrame
        },
        setErrorFromServer(state, error) {
            state.errorFromServer = error
        }
    },
    actions: {
        autoSetCardAccounts (context) {
            let sessionCardAccounts = localStorage.getItem('sessionCardAccounts')
            if (sessionCardAccounts) {
                sessionCardAccounts = crypto.AES.decrypt(sessionCardAccounts, '147258369').toString(crypto.enc.Utf8)
                context.commit('setCardAccounts', JSON.parse(sessionCardAccounts))
            }
        },
        logout (context) {
            context.commit('setCardAccounts', null)
            localStorage.removeItem('sessionCardAccounts')
        }
    },
    modules: {}
})
